import { render } from "./hello.vue?vue&type=template&id=3f4d5938&ts=true"
import script from "./hello.vue?vue&type=script&lang=ts"
export * from "./hello.vue?vue&type=script&lang=ts"

import "./hello.vue?vue&type=style&index=0&id=3f4d5938&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__